import { COLOR_MODES, COLUMNS, type ColorMode, type Task, URGENCY, NONE_KEY, colorInfo, colorKeys, localToday } from '@quadro/domain';
import { Options } from '../../components/Options';
import { useUI } from '../../state/ui';
import { useWorkspace } from '../../state/workspace';

/** "Colorir por" e os chips que filtram pelas cores. */
export function ColorBar({ tasks }: { tasks: Task[] }) {
  const ws = useWorkspace();
  const { colorBy, colorFilter, set } = useUI();
  const today = localToday();
  const counts: Record<string, number> = {};
  if (colorBy !== 'none') tasks.forEach(t => colorKeys(t, colorBy, ws.settings, today).forEach(k => { counts[k] = (counts[k] || 0) + 1; }));
  let order = Object.keys(counts);
  if (colorBy === 'urgency') order = Object.keys(URGENCY).filter(k => counts[k]);
  else if (colorBy === 'status') order = COLUMNS.map(c => c.id as string).filter(k => counts[k]);
  else order.sort((a, b) => Number(a === NONE_KEY) - Number(b === NONE_KEY) || counts[b] - counts[a]);
  const active = colorFilter.filter(k => order.includes(k));
  const toggle = (k: string) => set({ colorFilter: active.includes(k) ? active.filter(x => x !== k) : [...active, k] });

  return (
    <div className="corbar">
      <label className="cor-sel">Colorir por
        <select aria-label="Colorir os cartões por" value={colorBy} onChange={e => set({ colorBy: e.target.value as ColorMode, colorFilter: [] })}>
          <Options items={COLOR_MODES} />
        </select>
      </label>
      <div className="cor-chips" role="group" aria-label="Filtrar pelas cores">
        {order.map(k => {
          const i = colorInfo(k, colorBy, ws.settings, ws.person)!;
          const on = active.includes(k);
          return (
            <button key={k} type="button" className={`cor-chip ${on ? 'on' : ''} ${i.empty ? 'vazio' : ''}`} aria-pressed={on}
              style={{ '--kc': i.color } as React.CSSProperties} title={on ? 'Remover do filtro' : 'Mostrar só estes'} onClick={() => toggle(k)}>
              <i />{i.name}<span>{counts[k]}</span>
            </button>
          );
        })}
      </div>
      {active.length > 0 && <button type="button" className="side-link" onClick={() => set({ colorFilter: [] })}>Mostrar todos</button>}
    </div>
  );
}
